import { buildSpec, type RenderOptions } from "@/lib/resumeRender/catalog";
import type { PageSpec } from "@/lib/resumeRender/ir";
import { SECTION_ICON_BY_ID } from "@/lib/resumeRender/sectionIcons";
import { buildRenderModel } from "./renderModel";
import { DENSITY_FACTORS, type Resume } from "./types";

// A builder resume → the renderer's options → one page design.

export function renderOptions(r: Resume, o: { placeholders?: boolean; templateId?: string } = {}): RenderOptions {
  return {
    model: buildRenderModel(r, { placeholders: o.placeholders }),
    templateId: o.templateId ?? r.templateId,
    pageSize: r.pageSize,
    bodyFont: r.fontFamily,
    headingFont: r.design.headingFont,
    fontScale: r.fontScale,
    density: DENSITY_FACTORS[r.design.density],
    accent: r.design.accentColor,
    textColor: r.design.textColor,
    iconStyle: r.design.iconStyle,
    sectionIcons: r.design.sectionIcons ? SECTION_ICON_BY_ID : null,
    showSkillLevels: r.design.showSkillLevels,
  };
}

/** The page design of [r] (optionally in another template, for thumbnails). */
export function resumeSpec(r: Resume, o: { placeholders?: boolean; templateId?: string } = {}): PageSpec {
  return buildSpec(renderOptions(r, o));
}
